import React from 'react';
import { Box, Typography, FormHelperText } from '@mui/material';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

// Styles for flatpickr to match MUI
const flatpickrStyles = {
  width: '100%',
  padding: '16.5px 14px',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: '1rem',
  lineHeight: '1.4375em',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: '4px',
  backgroundColor: 'transparent',
  transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  "&:hover": {
    borderColor: 'rgba(0, 0, 0, 0.87)'
  },
  "&:focus": {
    borderColor: '#1976d2',
    borderWidth: '2px',
    outline: 'none'
  }
};

// Add a custom CSS class for error state
const customStyles = `
  .flatpickr-error {
    border-color: #d32f2f !important;
  }
  
  .flatpickr-calendar {
    box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
    border-radius: 4px;
  }

  .flatpickr-day.selected,
  .flatpickr-day.startRange,
  .flatpickr-day.endRange,
  .flatpickr-day.selected.inRange,
  .flatpickr-day.startRange.inRange,
  .flatpickr-day.endRange.inRange,
  .flatpickr-day.selected:focus,
  .flatpickr-day.startRange:focus,
  .flatpickr-day.endRange:focus,
  .flatpickr-day.selected:hover,
  .flatpickr-day.startRange:hover,
  .flatpickr-day.endRange:hover,
  .flatpickr-day.selected.prevMonthDay,
  .flatpickr-day.startRange.prevMonthDay,
  .flatpickr-day.endRange.prevMonthDay,
  .flatpickr-day.selected.nextMonthDay,
  .flatpickr-day.startRange.nextMonthDay,
  .flatpickr-day.endRange.nextMonthDay {
    background: #1976d2;
    border-color: #1976d2;
  }

  .flatpickr-time input:hover,
  .flatpickr-time .flatpickr-am-pm:hover,
  .flatpickr-time input:focus,
  .flatpickr-time .flatpickr-am-pm:focus {
    background: #f3f3f3;
  }

  .flatpickr-input:disabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.38);
    cursor: not-allowed;
  }
`;

// Flatpickr wrapper component for consistent styling with TextField
const StyledFlatpickr = ({ label, value, onChange, options, disabled, error, helperText }) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <style>{customStyles}</style>
      <Typography 
        sx={{ 
          position: 'absolute', 
          top: -9, 
          left: 14, 
          backgroundColor: 'white', 
          px: 0.5, 
          fontSize: '0.75rem',
          color: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}
      >
        {label}
      </Typography>
      <Flatpickr
        value={value}
        onChange={onChange}
        options={{
          ...options,
          disableMobile: true, // Better experience on mobile
          static: true,
        }}
        style={{
          ...flatpickrStyles,
          borderColor: error ? '#d32f2f' : undefined,
        }}
        disabled={disabled}
        className={error ? 'flatpickr-error' : ''}
      />
      {helperText && (
        <FormHelperText error={error}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default StyledFlatpickr;